<template>
  <main>
    <div class="notification is-danger" v-if="showError">
      An error was encountered trying to retrieve your transactions. Please
      check your network connection and try again.
    </div>
    <section id="transactions" class="columns" style="margin-top: 0px" v-else>
      <div class="panel column mr-4 is-success">
        <p class="panel-heading">Approved</p>
        <div class="panel-block" v-for="tx in approvedTX" :key="tx.transferId">
          <div>
            <span class="userFrom"
              >{{ toProperCase(tx.userFrom.username) }}
            </span>
            paid
            <span class="userTo">{{ toProperCase(tx.userTo.username) }}</span>
            <div class="feed-item-body">
              <span class="amount has-text-success"
                >${{ tx.amount.toFixed(2) }}</span
              >
              <span class="status-type">
                {{ tx.transferStatus }}: ID #{{ tx.transferId }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="panel column mr-4 is-warning">
        <p class="panel-heading">Pending</p>
        <div class="panel-block" v-for="tx in pendingTX" :key="tx.transferId">
          <div>
            <span class="userFrom"
              >{{ toProperCase(tx.userTo.username) }}
            </span>
            requesting from
            <span class="userTo">{{ toProperCase(tx.userFrom.username) }}</span>
            <div class="feed-item-body">
              <span class="amount has-text-warning"
                >${{ tx.amount.toFixed(2) }}</span
              >
              <span class="status-type">
                {{ tx.transferStatus }}: ID #{{ tx.transferId }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="panel column mr-4 is-danger" style="margin-bottom: 1.5rem">
        <p class="panel-heading">Rejected</p>
        <div class="panel-block" v-for="tx in rejectedTX" :key="tx.transferId">
          <div>
            <span class="userFrom"
              >{{ toProperCase(tx.userFrom.username) }}
            </span>
            rejected sending
            <span class="userTo">{{ toProperCase(tx.userTo.username) }}</span>
            <div class="feed-item-body">
              <span class="amount has-text-danger"
                >${{ tx.amount.toFixed(2) }}</span
              >
              <span class="status-type">
                {{ tx.transferStatus }}: ID #{{ tx.transferId }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import accountService from "@/services/AccountService";

export default {
  name: "news-feed",
  data() {
    return {
      showError: false,
    };
  },
  computed: {
    transactions() {
      // Anderson here, working on replacing the derived properties
      let tx2 = this.$store.state.transactions.map((item) => {
        item.sendType = item.transferType == "Send";
        item.requestType = item.transferType == "Request";
        item.approved = item.transferStatus == "Approved";
        item.pending = item.transferStatus == "Pending";
        item.rejected = item.transferStatus == "Rejected";
        return item;
      });
      return tx2; //this.$store.state.transactions;
    },
    pendingTX() {
      let ptx = this.$store.state.transactions.filter((item) => {
        return item.transferStatus.toLowerCase() == "pending";
      });
      return ptx;
    },
    approvedTX() {
      let ptx = this.$store.state.transactions.filter((item) => {
        return item.transferStatus.toLowerCase() == "approved";
      });
      return ptx;
    },
    rejectedTX() {
      let ptx = this.$store.state.transactions.filter((item) => {
        return item.transferStatus.toLowerCase() == "rejected";
      });
      return ptx;
    },
  },
  methods: {
    toProperCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
  },
  created() {
    accountService
      .getTransfers()
      .then((response) => {
        this.$store.commit("SET_TRANSACTIONS", response.data);
        this.showError = false;
      })
      .catch(() => {
        this.showError = true;
      });
  },
};
</script>

<!-- <style>
.status-type {
    color: black;
    font-size: 14px;
    margin-left: 10px;
    font-style: italic;
}
.feed-item-header {
    font-size: 16px;
    font-weight: bold;
}
.feed-item {
    padding: 10px;
    margin-bottom: 10px;
}
</style> -->